//Indavideo messageboxes

var iconsClasses64 = new Array();

 iconsClasses64['warning'] = 'icon-warning-64';
 iconsClasses64['info'] = 'icon-info-64';
 iconsClasses64['question'] = 'icon-question-64';
 iconsClasses64['critical'] = 'icon-critical-64';
 iconsClasses64['progress'] = 'icon-progress-64';

$(document).ready(function() {

	//msgOk('aw', 'ds', 'warning', function(){window.location = '/myprofile';});

	$('#passuser').focus(function(){
		if ($(this).val() == 'E-mail cím'){
			$(this).val('');
		}
	});

	$('#passuser').blur(function(){
		if ($(this).val() == ''){
			$(this).val('E-mail cím');
		}
	});

	$('#fakepass').focus(function(){
		if ($(this).val() == 'Jelszó'){
			$(this).hide();
			$('#passpass').show();
			$('#passpass').focus();
		}
	});

	$('#passpass').blur(function(){
		if ($(this).val() == ''){
			$(this).hide();
			$('#fakepass').show();
		}
	});

	funcYes = function(){ alert("igen!"); }
	funcNo = function(){ alert("nem!"); }

    $(document).keyup(function(event){
        if ( event.keyCode == 27 && !$("body").hasClass('force')) {
            $.unblockUI();
        }
    });

	//msgYesNo('Mit akarsz?', 'Igen vagy nem?', 'info', funcYes, funcNo);
});

function msgOk(title, text, type, callback)
{
	$('#messageboxOk > * #msgTitle').text(title);
	$('#messageboxOk > * #msgText').html(text);
	$('#messageboxOk > * #msgIcon').removeClass();
	$('#messageboxOk > * #msgIcon').addClass(this.iconsClasses64[type]);

	$.blockUI({ message: $('#messageboxOk'), css: { border : 'none', background : 'none' }  });

	$('#messageboxOk > * #msgOk').unbind();
	$('#messageboxOk > * #msgOk').click(function(){
	    $.unblockUI();
	    setTimeout(function(){if (callback){callback()};}, 400);
	});
	$('.blockOverlay').click($.unblockUI);
	$('* .btn_close').click($.unblockUI);
}

function msgSubscribePromoOk(callback)
{
	$('#messageboxSubscribePromoOk > * #msgIcon').removeClass();

	$.blockUI({ message: $('#messageboxSubscribePromoOk'), css: { width: "640px", top: "20%", border : 'none', background : 'none' }  });

	$('#messageboxSubscribePromoOk > * #msgText').unbind();
	$('.blockOverlay').click($.unblockUI);
	$('* .btn_close').click($.unblockUI);
}

function msgPlayerBox(url, callback)
{
	console.info('url:',url);
	$('#messageboxPlayerBox > * #msgIcon').removeClass();

	var origin_content = $('#messageboxPlayerBox .content').html();
	$.blockUI({ message: $('#messageboxPlayerBox'), css: { maxWidth: "730px", minWidth: "360px", width: "100%", height: "auto", maxHeight: "450px", top: 0, bottom: 0, left: 0, right: 0, margin: "auto", border : 'none', background : 'none', cursor: "pointer" }, overlayCSS: { cursor: "pointer" }, isPlayerBox : true });
	$("#messageboxPlayerBox .content .content").html('<div class="playerBoxLoader"><img src="'+IV.assetsUrl+'images/default/overlay_loading.png"><div></div></div>');

	$("#messageboxPlayerBox .content .playerBoxLoader img").animate({
		opacity: 1
	}, 1500, "easeInExpo", function() {
		var overlayPulse = setInterval(function() {
			if ($("#messageboxPlayerBox .content .playerBoxLoader").length !== 0) {
				$("#messageboxPlayerBox .content .playerBoxLoader div").animate({
					opacity: 0.9
				},1500,"easeInSine",function() {
					$(this).animate({
						opacity: 0
					},1500,"easeOutSine");
				});
			}
			else {
				clearInterval(overlayPulse);
			}
		}, 3000);
	});

	$('#messageboxPlayerBox .content .content').load(url, function(data) {
		$('#'+parent.parent.playerTargetDOM).hide();
		$('#'+parent.parent.playerTargetDOM).fadeIn(50, function(){
			initializeTabbing();
			if (videoBoxLoadedCallbackFunctionName) {
				eval(videoBoxLoadedCallbackFunctionName + '()');
			}
		});
	});

	$('#messageboxPlayerBox .content iframe').attr("src", $('#messageboxPlayerBox .content iframe').attr("src")+"&red=1");
	$('#messageboxPlayerBox > * #msgText').unbind();
	$('#messageboxPlayerBox > * #msgText').click(function(){
		location.hash = "";
		$('#messageboxPlayerBox .content').html(origin_content);
		$.unblockUI();
	});

	$(document).on("keypress","body",function(e){
		var code = e.charCode || e.keyCode || e.which;
		if (code == 27) {
			$.unblockUI();
			location.hash = "";
			$('#messageboxPlayerBox .content').html(origin_content);
		}
	});

	$('.blockOverlay').click(function(){
		location.hash = "";
		$('#messageboxPlayerBox .content').html(origin_content);
		$.unblockUI();
	});

	$('* .btn_close').click(function(){
		location.hash = "";
		$('#messageboxPlayerBox .content').html(origin_content);
		$.unblockUI();
	});
}

function msgLogin(force,redirUrl,title)
{
	if ($(".indpl_info p span").text() === "")
		$(".indpl_info p span").text("Lépj");

    if (title)
        $('#messageboxUserLogin .indpl_info p span').text(title);

    if (!force) {
    	if (redirUrl) {
	        $('#messageboxUserLogin').keypress(function(event){
	        	if ( event.keyCode == 13) login();
	        });
	        $('.blockOverlay').click(function() {
	        	removeErrorParamsFromUri();
	        	$.unblockUI();
	        });
	        $('* .btn_close').click(function() {
	        	removeErrorParamsFromUri();
	        	$.unblockUI();
	        });
	        $('#messageboxUserLogin > * #msgFinishBtn').unbind();
	        $('#messageboxUserLogin > * #msgFinishBtn').click(function(){
	        	removeErrorParamsFromUri();
	            $.unblockUI();
	        });

	        $(".indpl_fb_login .indpl_container").attr("href",$(".indpl_fb_login .indpl_container").attr("href").replace(/url\=[a-zA-Z0-9\_\-\:\/\.]+/g,"url="+encodeURIComponent(redirUrl)));
	        $(".indpl_formContainer .indapass_elfelejtett_jelszo").attr("href",$(".indpl_formContainer .indapass_elfelejtett_jelszo").attr("href").replace(/redirect_to\=[a-zA-Z0-9\_\-\:\/\.]+$/g,"redirect_to="+encodeURIComponent(redirUrl)));
	        // console.log(encodeURIComponent(redirUrl));
	        // $("#messageboxUserLogin .suggestion a").attr("href",$("#messageboxUserLogin .suggestion a").attr("href").replace(/redirect_to\=[a-zA-Z0-9\_\-\:\/\.]+\Z/g,redirUrl));
	        $("#indpl_login_box_640 input.redirect_to").val(redirUrl);
	    }
        else {
        	$('#messageboxUserLogin').keypress(function(event){
        	if ( event.keyCode == 13) login();
	        });
	        $('.blockOverlay').click(function() {
	        	removeErrorParamsFromUri();
	        	$.unblockUI();
	        });
	        $('* .btn_close').click(function() {
	        	removeErrorParamsFromUri();
	        	$.unblockUI();
	        });
	        $('#messageboxUserLogin > * #msgFinishBtn').unbind();
	        $('#messageboxUserLogin > * #msgFinishBtn').click(function(){
	        	removeErrorParamsFromUri();
	            $.unblockUI();
	        });
        }
    } else {
        $('body').addClass("force");
        $('.blockOverlay').click($.unblockUI);
        $('#messageboxUserLogin > * .btn_close').click(function() { window.location = "/";});
        $('#messageboxUserLogin > * #msgFinishBtn').removeClass();
		$('* .btn_close').click(function(){
			window.location = "http://indavideo.hu";
		});

    }

	$.blockUI({ message: $('#messageboxUserLogin'), css: { border : 'none', background : 'none' }  });
}

function msgUserReg(force,username)
{
    if (!force) {
		if ($.cookie("create-new-user") !== "1" || arguments.callee.caller !== null) {
			$.cookie("create-new-user", 1, { expires: 1, path: '/', domain: 'indavideo.hu' });
/*
			$('#messageboxChooseUsername').keypress(function(event){
				if ( event.keyCode == 13) login();
			});
*/

			$('.blockOverlay').click(function() {
				$.unblockUI();
				_gaq.push(['_trackEvent', 'Regisztráció', 'ForcedRegCanceled', IVUser.page]);
			});
			$('#messageboxChooseUsername > * .btn_close').click(function() {
				$.unblockUI();
				_gaq.push(['_trackEvent', 'Regisztráció', 'ForcedRegCanceled', IVUser.page]);
			});
			$('#messageboxChooseUsername > * #msgFinishBtn').unbind();
			$('#messageboxChooseUsername > * #msgFinishBtn').click(function(){
				$.unblockUI();
				_gaq.push(['_trackEvent', 'Regisztráció', 'ForcedRegCanceled', IVUser.page]);
			});
			$.blockUI({ message: $('#messageboxChooseUsername'), css: { border : 'none', background : 'none' }  });
		}
    } else {
        $('body').addClass("force");
        $('.blockOverlay').click($.unblockUI);
        $('#messageboxChooseUsername > * .btn_close').click(function() { window.location = "/";});
        $('#messageboxChooseUsername > * #msgFinishBtn').removeClass();
		$.blockUI({ message: $('#messageboxChooseUsername'), css: { border : 'none', background : 'none' }  });
    }

    if (username !== "") {
        $('#messageboxChooseUsername #new-name').val(username);
    }
}


function msgYesNo(title, text, type, functionIfYes, functionIfNo)
{
	$('#messageboxYesNo > * #msgTitle').text(title);
	$('#messageboxYesNo > * #msgText').text(text);
	$('#messageboxYesNo > * #msgIcon').removeClass();
	$('#messageboxYesNo > * #msgIcon').addClass(this.iconsClasses64[type]);

	$.blockUI({ message: $('#messageboxYesNo'), css: { border : 'none', background : 'none' }  });

	//Answer yes:
	$('#messageboxYesNo > * #msgYes').unbind();
        $('#messageboxYesNo > * #msgYes').click(function(){
            $.unblockUI();
            setTimeout(function(){
                if (functionIfYes && typeof functionIfYes == "string") {
                    functionIfYes();
                }
                else if (functionIfYes && typeof functionIfYes == "object") {
                    var fy = functionIfYes;
                    if (fy.doFunction && fy.args) {
                        fy.doFunction(fy.args);
                    }
                }
            }, 400);
	});
	//Answer no:
	$('#messageboxYesNo > * #msgNo').unbind();
	$('#messageboxYesNo > * #msgNo').click(function(){
	    $.unblockUI();
	    setTimeout(function(){
                if (functionIfNo && typeof functionIfNo == "string") {
                    functionIfNo();
                }
                else if (functionIfNo && typeof functionIfNo == "object") {
                    var fn = functionIfNo;
                    if (fn.doFunction && fn.args) {
                        fn.doFunction(fn.args);
                    }
                }
            }, 400);
	});
	$('.blockOverlay').unbind();
	$('.blockOverlay').click($.unblockUI);
	$('* .btn_close').unbind();
	$('* .btn_close').click($.unblockUI);
}

function msgYesNoAjax(title, text, type, functionIfYes, functionIfNo)
{
	$('#messageboxYesNo > * #msgTitle').text(title);
	$('#messageboxYesNo > * #msgText').text(text);
	$('#messageboxYesNo > * #msgIcon').removeClass();
	$('#messageboxYesNo > * #msgIcon').addClass(this.iconsClasses64[type]);
	$.blockUI({ message: $('#messageboxYesNo'), css: { border : 'none', background : 'none' }  });
	//Answer yes:
	$('#messageboxYesNo > * #msgYes').unbind();
        $('#messageboxYesNo > * #msgYes').click(function(){
    	    $.unblockUI();
     	    setTimeout(function(){if (functionIfYes){functionIfYes()};}, 400);
     	});
	//Answer no:
	$('#messageboxYesNo > * #msgNo').unbind();
	$('#messageboxYesNo > * #msgNo').click(function(){
	    $.unblockUI();
     	    setTimeout(function(){if (functionIfYes){functionIfNo()};}, 400);
	});
	$('.blockOverlay').unbind();
	$('.blockOverlay').click($.unblockUI);
	$('* .btn_close').unbind();
	$('* .btn_close').click($.unblockUI);
}

function msgAdultYesNo(title, text, type, functionIfYes, functionIfNo)
{
	$('#messageboxYesNo > * #msgTitle').text("18 elmúltál-e?");
	$('#messageboxYesNo > * #msgText').html("Az oldalon található videók a <a href=\"http://www.complex.hu/jr/gen/hjegy_doc.cgi?docid=A1000185.TV\"> médiaszolgáltatásokról és a tömegkommunikációról szóló törvény </a> besorolása szerint a kiskorúakra veszélyes kategóriába tartoznak. Ha te kiskorú vagy, semmiképp ne nézd meg őket. Ha felnőtt vagy, és szeretnéd, hogy az ilyen tartalmakhoz kiskorú ne férhessen hozzá, használj <a href=\"http://www.mte.hu/gyerekzar/gyerekzar_minisite.html\" target=\"_blank\" onclick=\"_gaq.push(['_trackEvent', '18+', 'szűrőprogram link']);\">szűrőprogramot</a>. Ha felnőtt vagy, kattints az igenre.");
	$('#messageboxYesNo > * #msgIcon').removeClass();
	$('#messageboxYesNo > * #msgIcon').addClass(this.iconsClasses64[type]);

	$.blockUI({ message: $('#messageboxYesNo'), css: { border : 'none', background : 'none' }  });

	//Answer yes:
	$('#messageboxYesNo > * #msgYes').unbind();
        $('#messageboxYesNo > * #msgYes').click(function(){
	    $('div.item_inner a.image[imagerestricted=1]').each
	    (
		function(i,e)
		{
		    $(e).find('div.crop img').attr('src',$(e).attr('imageoriginal'));

		    if ($(e).find('div.crop').attr("style") != "") {
		    	$(e).find('div.crop').css({
		    		background: 'url(' + $(e).attr('imageoriginal') + ') no-repeat center center transparent'
		    	});
		    }
		}
	    );
    	    $.unblockUI();

			setCookie ('indavideoErotika', 1 , 1, '/', 'indavideo.hu', false);
			_gaq.push(['_trackEvent', '18+', 'igen']);
     	    setTimeout(function(){if (functionIfYes){functionIfYes()};}, 400);
	});
	//Answer no:
	$('#messageboxYesNo > * #msgNo').unbind();
	$('#messageboxYesNo > * #msgNo').click(function(){

			_gaq.push(['_trackEvent', '18+', 'nem']);
			window.location="http://indavideo.hu";

	});
	$('.blockOverlay').css('opacity', '0.8');
	$('* .btn_close').css('display', 'none');
}

function removeErrorParamsFromUri() {
	var location = window.location.href;
	var pageurl = location.split("?")[0];
	var url_params = (location.split("?").length > 1) ? location.split("?")[1].split("&") : [];
	var url_params2 = [];

	if (url_params.length !== 0) {
		$.each(url_params, function(index,param) {
			if (!/error[a-zA-Z\_\-]*\=[a-zA-Z0-9]+/g.test(param)) {
				url_params2.push(param);
			}
		});

		url_params = url_params2.join("&");
		if (url_params.length == 0)
			window.history.pushState({path:pageurl},'',pageurl);
		else
			window.history.pushState({path:pageurl+"?"+url_params},'',pageurl+"?"+url_params);
	}
}

/*
function msgYesNoCancel(title, text, yesFunction, noFunction){
	var divYesNoCancel = "<div id='boxYesNoCancel'><div class='title'>"+title+"</div><div class='text'>"+text+"</div><div class='buttons'><span class='btn_yes'></span><span class='btn_no'></span><span class='btn_cancel' onclick='$.unblockUI();'></span></div></div>";
	$.blockUI({ message: divYesNoCancel, css: { border : 'none', background : 'none' } });
	$('#boxYesNoCancel > .buttons > .btn_yes').click(yesFunction);
	$('#boxYesNoCancel > .buttons > .btn_no').click(noFunction);
	$('.blockOverlay').click($.unblockUI);
}
*/

